import { render, staticRenderFns } from "./SvgResource.vue?vue&type=template&id=d9c83a56"
import script from "./SvgResource.vue?vue&type=script&lang=js"
export * from "./SvgResource.vue?vue&type=script&lang=js"
import style0 from "./SvgResource.vue?vue&type=style&index=0&id=d9c83a56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports